<ng-template #modalCNameDetails let-c="close" let-d="dismiss">
  <wsb-modal
    title="{{ '' | translate }}"
    [primaryButtonEnable]="false"
    [cancelButtonEnable]="true"
    (dismiss)="d()"
    (primary)="d()"
    text="{{ '' | translate }}"
  >
    <div body>
      <div class="mb-4" [innerHtml]="'emaildns_config_help' | translate"></div>
      <div class="d-flex">
        <table class="pop-up-table">
          <thead>
            <tr>
              <th translate>emaildns_details_cname</th>
              <th translate>emaildns_details_host</th>
              <th></th>
              <th translate>emaildns_details_value</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="domainForAutoEmail?.dns?.dkim1">
              <td>{{ domainForAutoEmail?.dns?.dkim1?.type | uppercase }}</td>
              <td>
                {{ domainForAutoEmail?.dns?.dkim1?.host }}
              </td>
              <td>
                <button class="btn  btn-primary  btn-sm" [cdkCopyToClipboard]="domainForAutoEmail?.dns?.dkim1?.host" translate>
                  common_copy
                </button>
              </td>
              <td class="border-left">{{ domainForAutoEmail?.dns?.dkim1?.data }}</td>
              <td>
                <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="domainForAutoEmail?.dns?.dkim1?.data" translate>
                  common_copy
                </button>
              </td>
            </tr>

            <tr *ngIf="domainForAutoEmail?.dns?.dkim2">
              <td>{{ domainForAutoEmail?.dns?.dkim2?.type | uppercase }}</td>
              <td>
                {{ domainForAutoEmail?.dns?.dkim2?.host }}
              </td>
              <td>
                <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="domainForAutoEmail?.dns?.dkim2?.host" translate>
                  common_copy
                </button>
              </td>
              <td class="border-left">{{ domainForAutoEmail?.dns?.dkim2?.data }}</td>
              <td>
                <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="domainForAutoEmail?.dns?.dkim2?.data" translate>
                  common_copy
                </button>
              </td>
            </tr>

            <tr *ngIf="domainForAutoEmail?.dns?.mailCname">
              <td>{{ domainForAutoEmail?.dns?.mailCname?.type | uppercase }}</td>
              <td>
                {{ domainForAutoEmail?.dns?.mailCname?.host }}
              </td>
              <td>
                <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="domainForAutoEmail?.dns?.mailCname?.host" translate>
                  common_copy
                </button>
              </td>
              <td class="border-left">{{ domainForAutoEmail?.dns?.mailCname?.data }}</td>
              <td>
                <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="domainForAutoEmail?.dns?.mailCname?.data" translate>
                  common_copy
                </button>
              </td>
            </tr>

            <tr *ngIf="domainForAutoEmail?.dns?.mailServer">
              <td>{{ domainForAutoEmail?.dns?.mailServer?.type | uppercase }}</td>
              <td>
                {{ domainForAutoEmail?.dns?.mailServer?.host }}
              </td>
              <td>
                <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="domainForAutoEmail?.dns?.mailServer?.host" translate>
                  common_copy
                </button>
              </td>
              <td class="border-left">{{ domainForAutoEmail?.dns?.mailServer?.data }}</td>
              <td>
                <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="domainForAutoEmail?.dns?.mailServer?.data" translate>
                  common_copy
                </button>
              </td>
            </tr>

            <tr *ngIf="domainForAutoEmail?.dns?.spf">
              <td>{{ domainForAutoEmail?.dns?.spf?.type | uppercase }}</td>
              <td>
                {{ domainForAutoEmail?.dns?.spf?.host }}
              </td>
              <td>
                <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="domainForAutoEmail?.dns?.spf?.host" translate>
                  common_copy
                </button>
              </td>
              <td class="border-left">{{ domainForAutoEmail?.dns?.spf?.data }}</td>
              <td>
                <button class="btn  btn-primary   btn-sm" [cdkCopyToClipboard]="domainForAutoEmail?.dns?.spf?.data" translate>
                  common_copy
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </wsb-modal>
</ng-template>

<div class="page">
  <div class="page__container" #page>
    <h1 class="page__title h2 mb-5">{{ 'reseller_settings_title' | translate }}</h1>
    <div class="my-5">
      <form [formGroup]="settingsForm">
        <div>
          <div>
            <div class="form-group row">
              <label for="domain" class="col-sm-4" translate>reseller_settings_domain</label>
              <div class="col-sm-5">
                <input
                  type="text"
                  name="domain"
                  formControlName="domain"
                  class="form-control  form-control--short"
                  *ngIf="profiles"
                  id="domain"
                  [readonly]="!profiles.length"
                />
                <small class="form-text text-muted" translate>reseller_settings_domain_help</small>
              </div>
            </div>
          </div>

          <div>
            <div class="form-group d-flex w-100 margin-adjustement">
              <label class="col-sm-4" translate>reseller_settings_use_custome_domain</label>
              <div class="w-100 padding-adjustement">
                <div class="form-check-inline" [ngClass]="{ 'disable-useDomain': useDomainForAutoEmail.value }">
                  <label class="radio-custom">
                    <input type="radio" [formControl]="useDomainForAutoEmail" [value]="false" />
                    <span class="radio-custom__radio"></span>
                    <span class="radio-custom__label" translate>common_no</span>
                  </label>
                  <label class="radio-custom">
                    <input type="radio" [formControl]="useDomainForAutoEmail" [value]="true" />
                    <span class="radio-custom__radio"></span>
                    <span class="radio-custom__label" translate>common_yes</span>
                  </label>
                </div>
                <small class="form-text text-muted" translate>reseller_settings_use_custome_domain_help</small>

                <div class="" *ngIf="showDomainForAutoEmail">
                  <table class="table">
                    <thead style="font-size: 13px;">
                      <tr>
                        <th translate>emaildns_domain</th>
                        <th translate>common_status</th>
                        <th class="text-end" translate>common_actions</th>
                      </tr>
                    </thead>
                    <tbody style="font-size: 12px;">
                      <tr>
                        <td>{{ domainForAutoEmail?.domain }}</td>
                        <td *ngIf="domainForAutoEmail?.valid" translate>emaildns_valid</td>
                        <td *ngIf="!domainForAutoEmail?.valid" translate>
                          emaildns_pending
                        </td>
                        <td class="text-end">
                          <a
                            (click)="dropdownClick()"
                            href="#"
                            id="atlas-gridgroup"
                            role="button"
                            data-display="static"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <wsb-atlas-button
                              id="atlas-gridgroup-btn"
                              class="mb-2"
                              [variant]="'primary'"
                              [icon]="faEllipsisH"
                            ></wsb-atlas-button>
                          </a>
                          <div
                            class="dropdown dropdown-buttongroup-arrow dropdown-menu  dropdown-menu-end pop-up"
                            id="atlas-gridgroup-m"
                            [attr.aria-labelledby]="'atlas-gridgroup'"
                          >
                            <ng-container *ngFor="let item of items; index as i">
                              <a class="dropdown-item" (click)="item.onClick()">{{ item.label | translate }}</a>
                            </ng-container>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="form-group row">
              <label for="domain" class="col-sm-4" translate>reseller_settings_logo</label>
              <div class="col-sm-5">
                <input type="file" id="logo" class="form-control  form-control--short" (change)="onLogoChange($event)" #fileInput /><br />
                <div class="d-flex align-items-center" *ngIf="!settingsForm.get('logoBase64').value">
                  <wsb-ui-checkbox
                    [(checked)]="removeExistingLogo"
                    (change)="settingsForm.markAsDirty()"
                    class="me-1 pt-1"
                  ></wsb-ui-checkbox>
                  <span class="ms-2" translate>reseller_settings_remove_existing_logo</span>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="form-group row">
              <label class="col-sm-4" for="shopEnabledForm" translate>reseller_settings_titlecolor</label>
              <div class="col-sm-2">
                <input
                  *ngIf="cloneForm"
                  class="form-control  form-control--short"
                  [(colorPicker)]="cloneForm.titleColor"
                  [style.background]="cloneForm.titleColor"
                  (colorPickerChange)="changeColor($event, 'titleColor')"
                />
              </div>
            </div>
          </div>
          <div>
            <div class="form-group row">
              <label class="col-sm-4" for="shopEnabledForm" translate>reseller_settings_buttoncolor</label>
              <div class="col-sm-2">
                <input
                  *ngIf="cloneForm"
                  class="form-control  form-control--short"
                  [(colorPicker)]="cloneForm.buttonColor"
                  [style.background]="cloneForm.buttonColor"
                  (colorPickerChange)="changeColor($event, 'buttonColor')"
                />
              </div>
            </div>
          </div>
          <div>
            <div class="form-group row">
              <label class="col-sm-4" for="shopEnabledForm" translate>reseller_settings_shop</label>
              <div class="col-sm-2">
                <div id="shopEnabledForm" class="form-check-inline">
                  <label class="radio-custom">
                    <input type="radio" name="shopEnabled" formControlName="shopEnabled" [value]="true" />
                    <span class="radio-custom__radio"></span>
                    <span class="radio-custom__label" translate>reseller_settings_shop_yes</span>
                  </label>
                  <label class="radio-custom">
                    <input type="radio" name="shopEnabled" formControlName="shopEnabled" [value]="false" />
                    <span class="radio-custom__radio"></span>
                    <span class="radio-custom__label" translate>common_no</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="form-group row">
              <label class="col-sm-4" for="shopEnabledForm" translate>reseller_settings_shop_url</label>
              <div class="col-sm-5">
                <input
                  type="text"
                  name="domain"
                  formControlName="shopUrl"
                  class="form-control  form-control--short"
                  id="domain"
                  [readonly]="settingsForm.get('shopEnabled').value === false"
                  placeholder="{{ 'reseller_settings_shop_url' | translate }}"
                />
                <small class="form-text text-muted" translate>reseller_settings_shop_url_help</small>
              </div>
            </div>
          </div>
          <div>
            <div class="form-group row">
              <label class="col-sm-4" for="shopEnabledForm" translate>reseller_settings_edit</label>
              <div class="col-sm-6">
                <div id="shopEnabledForm" class="form-check-inline">
                  <label class="radio-custom">
                    <input type="radio" name="showSubSettings" formControlName="showSubSettings" [value]="true" />
                    <span class="radio-custom__radio"></span>
                    <span class="radio-custom__label" translate>reseller_settings_edit_yes</span>
                  </label>
                  <label class="radio-custom">
                    <input type="radio" name="showSubSettings" formControlName="showSubSettings" [value]="false" />
                    <span class="radio-custom__radio"></span>
                    <span class="radio-custom__label" translate>common_no</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="form-group row">
              <label class="col-sm-4" for="shopEnabledForm" translate>reseller_settings_password</label>
              <div class="col-sm-6">
                <div id="shopEnabledForm" class="form-check-inline">
                  <label class="radio-custom">
                    <input type="radio" name="disablePasswordChange" formControlName="disablePasswordChange" [value]="false" />
                    <span class="radio-custom__radio"></span>
                    <span class="radio-custom__label" translate>reseller_settings_password_yes</span>
                  </label>
                  <label class="radio-custom">
                    <input type="radio" name="disablePasswordChange" formControlName="disablePasswordChange" [value]="true" />
                    <span class="radio-custom__radio"></span>
                    <span class="radio-custom__label" translate>common_no</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="form-group row">
              <label for="domain" class="col-sm-4" translate>reseller_settings_creditsnames</label>
              <div class="col-sm-2">
                <div
                  class="mb-1"
                  formArrayName="messageTypeLabels"
                  *ngFor="let item of settingsForm.get('messageTypeLabels')['controls']; let i = index"
                >
                  <div [formGroupName]="i">
                    <input
                      type="text"
                      name="label"
                      formControlName="label"
                      class="form-control  form-control--short"
                      placeholder="{{ settingsForm.controls.messageTypeLabels['controls'][i].label }}"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- <div [ngbNavOutlet]="nav" class="mt-2"></div> -->
    <div class="page__actions  actions-bar" #actionsBar style="z-index: 1">
      <span class="actions-bar__bg"></span>
      <div class="actions-bar__container" toastContainer></div>
      <div class="actions-bar__container  actions-bar__container--actions">
        <div class="d-flex">
          <button
            #submitBtn
            class="btn  btn-primary   btn-sm"
            [disabled]="settingsForm.invalid || (!setDomainForAutoEmail && settingsForm.pristine)"
            (click)="submitActiveForm()"
            translate
          >
            common_save
          </button>
          <button *ngIf="settingsForm.dirty" type="button" class="btn btn-link btn-sm ms-2" (click)="resetForm()" translate>
            common_cancel
          </button>
        </div>
        <div *ngIf="!settingsForm.pristine" class="mt-2">
          <span [inlineSVG]="'assets/images/icons/icon-info.svg'" class="info-icon  me-1"></span>
          <small translate>common_unsaved_changes</small>
        </div>
      </div>
    </div>
  </div>
</div>
